import '@styles/app.scss'
import '@daveberning/griddle/dist/grid.css'
import app from '@core/app'
import './registerServiceWorker'

app.mount('#app')
